<template>
    <div class="settings">
        <h1>{{$t('editTitle')}}</h1>
        <b-form>
            <b-form-group>
                <b-form-input v-model="rule.name" required
                        :placeholder="$t('namePlaceholder')"></b-form-input>
            </b-form-group>
            <b-form-group :label="$t('allConditions')" label-cols="4" label-for="manual-all">
                <b-checkbox switch v-model="rule.all" ref="all" id="manual-all"></b-checkbox>
            </b-form-group>
            <h3>{{$t('conditionsTitle')}}</h3>
            <b-container class="rows">
                <b-form-row v-for="(c, ind) in rule.conditions" :key="ind">
                    <b-col><b-form-select v-model="c.field" :options="fields"></b-form-select></b-col>
                    <b-col><b-form-select v-model="c.match" :options="matches"></b-form-select></b-col>
                    <b-col><b-form-input v-model="c.data"></b-form-input></b-col>
                    <div class="delete" @click="doDeleteCondition(ind)">
                        <font-awesome-icon icon="times" size="lg"></font-awesome-icon>
                    </div>
                </b-form-row>
                <b-row v-if="!rule.conditions.length">
                    <b-col @click="doAddCondition">{{$t('noConditions')}}</b-col>
                </b-row>
            </b-container>
            <b-button @click="doAddCondition">{{$t('addCondition')}}</b-button>

            <h3>{{$t('actionsTitle')}}</h3>
            <b-container class="rows">
                <b-form-row v-for="(a, ind) in rule.actions" :key="ind">
                    <b-col><b-form-select v-model="a.action" :options="actions"></b-form-select></b-col>
                    <b-col><b-form-select v-if="['move', 'copy'].indexOf(a.action)!==-1" :options="folders"
                            v-model="a.data"></b-form-select></b-col>
                    <div class="delete" @click="doDeleteCondition(ind)">
                        <font-awesome-icon icon="times" size="lg"></font-awesome-icon>
                    </div>
                </b-form-row>
                <b-row v-if="!rule.actions.length">
                    <b-col @click="doAddAction">{{$t('noActions')}}</b-col>
                </b-row>
            </b-container>
            <b-button @click="doAddAction">{{$t('addAction')}}</b-button><br/>

            <b-button variant="primary" :disabled="!isValid" @click="doSave">{{$t('save')}}</b-button>
            <b-button @click="$router.back()">{{$t('cancel')}}</b-button>

        </b-form>

    </div>
</template>

<script>
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

export default {
  name: 'manualRuleEditor',
  components: { FontAwesomeIcon },
  i18nOptions: { keyPrefix: 'rules.manualRules' },
  data: function() {
    return {
      rule: {
        name: '',
        all: false,
        conditions: [],
        actions: []
      },
      fields: [
        { value: 'subject', text: this.$t('condfields.subject') },
        { value: 'from', text: this.$t('condfields.from') }
      ],
      matches: [
        { value: 'contains', text: this.$t('condmatches.contains') },
        { value: 'notcontains', text: this.$t('condmatches.notContains') },
        { value: 'is', text: this.$t('condmatches.is') },
        { value: 'notis', text: this.$t('condmatches.notIs') },
        { value: 'begins', text: this.$t('condmatches.begins') },
        { value: 'ends', text: this.$t('condmatches.ends') }
      ],
      actions: [
        { value: 'move', text: this.$t('actions.move') },
        { value: 'copy', text: this.$t('actions.copy') },
        { value: 'markread', text: this.$t('actions.markRead') },
        { value: 'markunread', text: this.$t('actions.markUnread') },
        { value: 'flag', text: this.$t('actions.flag') },
        { value: 'delete', text: this.$t('actions.delete') }
      ]
    };
  },
  mounted() {
    const val = this.$route;
    console.log('new manualRuleEditor', val);
    if (val.params.ruleid === '-1') {
      if (this.$store.state.newRule) {
        this.rule = this.$store.state.newRule;
        this.$store.commit('setNewRule', null);
        console.log('load new from store');
      } else {
        this.rule = { name: '', all: false, conditions: [], actions: [] };
        console.log('load blank');
      }
    } else {
      this.rule = this.$store.state.settings.manualrules[parseInt(val.params.ruleid, 10)];
      console.log('load existing');
    }
  },
  methods: {
    doAddCondition() {
      this.rule.conditions.push({ field: 'from', match: 'is', data: '' });
    },
    doDeleteCondition(ind) {
      this.$delete(this.rule.conditions, ind);
    },
    doAddAction() {
      this.rule.actions.push({ action: 'markunread', data: this.folders[0].value });
    },
    doDeleteAction(ind) {
      this.$delete(this.rule.actions, ind);
    },
    doSave() {
      let r = this.$store.state.settings.manualrules;
      if (this.$route.params.ruleid === '-1') {
        r.push(this.rule);
      } else {
        const ind = parseInt(this.$route.params.ruleid, 10);
        r[ind] = this.rule;
      }
      this.$store.dispatch('setSetting', { name: 'manualrules', value: r });
      if (this.$route.params.ruleid === '-1') {
        this.$router.replace({ name: 'rules' });
      } else {
        this.$router.push({ name: 'rules' });
      }
    }
  },
  computed: {
    folders() {
      return this.$store.getters.getFoldersAsOptions;
    },
    isValid() {
      if (!this.rule.name.trim() || !this.rule.conditions.length || !this.rule.actions.length) {
        return false;
      }
      if (this.rule.conditions.find(c => {
        if (c.data === '') {
          if ((c.match !== 'is') && (c.match !== 'notis')) {
            return true;
          }
        }
        return false;
      })) {
        return false;
      }
      return true;
    }
  }
};
</script>

<style scoped>

</style>
